import AdaptiveImage from "../../../react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/down.256a6c86.png","uri@2x": __webpack_public_path__ + "static/media/down.4eaee826.png","uri@3x": __webpack_public_path__ + "static/media/down.40e623a5.png",
    width: 10,
    height: 12
});